/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { ProUnlockFeature } from '@/client/catalogs/proUnlock';

/*----------------------------------
- TYPES
----------------------------------*/

export type ProUnlockDetail = { feature: ProUnlockFeature; message?: string };

/*----------------------------------
- CONSTANTS
----------------------------------*/

export const PRO_UNLOCK_EVENT = 'crosspath:pro-unlock';

/*----------------------------------
- HELPERS
----------------------------------*/

/**
 * Asks the page to explain what Pro opens. With `cancelable`, the answer says whether someone took it up: when no
 * page is there to explain (or the user is not on the trial) the caller keeps its own message.
 */
export const requestProUnlock = (detail: ProUnlockDetail, cancelable = false): boolean =>
    !window.dispatchEvent(new window.CustomEvent<ProUnlockDetail>(PRO_UNLOCK_EVENT, { detail, cancelable }));
